// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Button } from "@hex-insights/core";
import {
	AddSubFormButtonRenderProps,
	DateTimeField,
	Form,
	FormType,
	RadioField,
	SubFormField,
	SubFormRenderProps,
	TextField,
} from "@hex-insights/forms";
import { InvoiceFormValues, InvoiceLineItemFormValues } from "../../FormUtilities";
import { ContractInstallmentSelectField } from "../ContractInstallment";
import { InvoiceLineItemForm } from "../InvoiceLineItem";
import { BaseFieldProps } from "../shared";

/**
 * Generic props for fields of the Invoice model.
 */
type FieldProps<K extends keyof InvoiceFormValues.Base = keyof InvoiceFormValues.Base> = BaseFieldProps<
	Pick<InvoiceFormValues.Base, K>
>;

/**
 * Generic props for fields of the Invoice model that only appear in the create form.
 */
type CreateFieldProps<K extends keyof InvoiceFormValues.Create = keyof InvoiceFormValues.Create> = BaseFieldProps<
	Pick<InvoiceFormValues.Create, K>
>;

/**
 * Field component for the `name` field of the Invoice model.
 */
export function Name({ formState, ...props }: FieldProps<"name">) {
	return <TextField formState={formState} name="name" {...props} />;
}

/**
 * Field component for the `status` field of the Invoice model.
 */
export function Status({ formState, ...props }: FieldProps<"status">) {
	return (
		<RadioField
			formState={formState}
			name="status"
			options={InvoiceFormValues.statusOptions}
			blankValue={null}
			optional={FormType.isCreate(formState.formType)}
			{...props}
		/>
	);
}

/**
 * Field component for the `issueDate` field of the Invoice model.
 */
export function IssueDate({ formState, ...props }: FieldProps<"issueDate">) {
	return <DateTimeField formState={formState} name="issueDate" precision="day" {...props} />;
}

/**
 * Field component for the `dueDate` field of the Invoice model.
 */
export function DueDate({ formState, ...props }: FieldProps<"dueDate">) {
	return <DateTimeField formState={formState} name="dueDate" precision="day" {...props} />;
}

/**
 * Field component for the `description` field of the Invoice model.
 */
export function Description({ formState, ...props }: FieldProps<"description">) {
	return <TextField formState={formState} name="description" multiLine optional {...props} />;
}

export namespace ContractInstallment {
	export type SelectProps = FieldProps<"contractInstallmentID"> &
		Omit<ContractInstallmentSelectField.SelectProps<InvoiceFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `contractInstallment` edge of the Invoice model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <ContractInstallmentSelectField.Select formState={formState} name="contractInstallmentID" {...props} />;
	}
}

export namespace InvoiceLineItems {
	/**
	 * SubForm field component for the `invoiceLineItems` edge of the Invoice model.
	 */
	export function SubForm({ formState, ...props }: CreateFieldProps<"invoiceLineItems">) {
		return (
			<SubFormField
				formState={formState}
				name="invoiceLineItems"
				blankItem={InvoiceLineItemFormValues.blankItemInInvoice}
				{...props}
			>
				{SubForm.SubForm}
				{SubForm.AddButton}
			</SubFormField>
		);
	}

	SubForm.SubForm = function ({
		formState,
		onRemoveClick,
	}: SubFormRenderProps<InvoiceLineItemFormValues.CreateInInvoice>) {
		return (
			<Form.Column>
				<Button variant="tertiary" size="small" onClick={onRemoveClick} disabled={formState.disabled}>
					Remove Invoice Line Item
				</Button>
				<InvoiceLineItemForm.CreateFieldsInInvoice formState={formState} />
			</Form.Column>
		);
	};

	SubForm.AddButton = function ({
		onClick,
		disabled,
	}: AddSubFormButtonRenderProps<
		Pick<InvoiceFormValues.Create, "invoiceLineItems">,
		InvoiceLineItemFormValues.CreateInInvoice
	>) {
		return (
			<Button variant="tertiary" size="small" onClick={onClick} disabled={disabled}>
				Add Invoice Line Item
			</Button>
		);
	};
}
